import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { EmployeeVoiceService } from 'src/app/services/employee-voice.service';

@Component({
  selector: 'app-view-employee-voice',
  templateUrl: './view-employee-voice.page.html',
  styleUrls: ['./view-employee-voice.page.scss'],
})
export class ViewEmployeeVoicePage implements OnInit {

  @Input() message:any;
  comment:any;

  constructor(private modalController:ModalController, private employeeService:EmployeeVoiceService, private router:Router) { }


  async ngOnInit() {
    this.employeeService.getComment(this.message.id).subscribe((res: any) => {
      console.log("res",res);
      this.comment = res.data;
      if (res.data) {
        this.comment = res.data;
      } 
    });
    console.log(this.message);
  }

  close(){
    this.modalController.dismiss();
  }

  reOpen(message){
    this.modalController.dismiss();
    this.router.navigate(["employee-voice/send-voice", { data: JSON.stringify(message)}]);
  }
}